import { Component, computed, input } from '@angular/core';
import { EManagementType } from 'src/models/common.model';
import { EInvestmentParameter, EWeeksBetweenInvestments, IInvestmentChangeDraftOut } from 'src/models/products.model';

interface IParameterChange<T> {
  before: T;
  after: T;
}

@Component({
  selector: 'liberro-investment-change-draft-card',
  standalone: false,
  templateUrl: './investment-change-draft-card.component.html',
  styleUrl: './investment-change-draft-card.component.less'
})
export class InvestmentChangeDraftCardComponent {
  public draft = input.required<IInvestmentChangeDraftOut>();

  public totalYearsToInvest = computed(() => this.getParameter(EInvestmentParameter.TOTAL_YEARS_TO_INVEST, Number));
  public regularDeposit = computed(() => this.getParameter(EInvestmentParameter.REGULAR_DEPOSIT, Number));
  public initialDeposit = computed(() => this.getParameter(EInvestmentParameter.INITIAL_DEPOSIT, Number));
  public weeksBetweenInvestments = computed(() =>
    this.getParameter(EInvestmentParameter.WEEKS_BETWEEN_INVESTMENTS, value => +value as EWeeksBetweenInvestments)
  );
  public strategyRebalance = computed(() => this.getParameter(EInvestmentParameter.STRATEGY_REBALANCE, value => value === 'true'));
  public currentStrategyRebalance = computed<boolean>(() => this.draft().strategyRebalance ?? false);
  public isStrategy = computed<boolean>(() => this.draft().portfolioManagementType === EManagementType.EXECUTION_ONLY);
  public compositionChanged = computed<boolean>(() => !!this.draft().compositionDiff.length);

  private getParameter<T>(name: EInvestmentParameter, parse: (value: string) => T): IParameterChange<T> | null {
    const parameter = this.draft().parameters.find(p => p.name === name);
    if (!parameter) {
      return null;
    }
    return {
      before: parse(parameter.before!),
      after: parse(parameter.after),
    };
  }
}
